import React, { useEffect, useState } from "react";
import DeviceListItem from "./DeviceListItem";

import GroupListItem from "./GroupListItem";
import {
  useDevice,
  useDeviceGroup,
  useDeviceGroups,
} from "../../Api/newSockets.api";
import Tabs from "../../components/Tabs/Tabs";
import { ReactComponent as GroupsIcon } from "../../assets/icons/workspaces.svg";
import { ReactComponent as DevicesIcon } from "../../assets/icons/devices.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../assets/icons/power.svg";
import Header from "../../components/Header/Header";
import Table from "../../components/Table/Table";
import Modal from "../../components/Modals/Modal";
import Input from "../../components/DataEntry/Input";
import AddButton from "../../components/Buttons/AddButton";
import Search from "../../components/Search/Search";
import validator from "validator";
import { ReactComponent as AddItemIcon } from "../../assets/icons/add.svg";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { savePathToLocalStorage } from "../../utils/helpers";

const Groups = () => {
  savePathToLocalStorage();
  const { deviceGroups, searchDeviceGroups, connected } = useDeviceGroups();
  const { addDeviceGroup } = useDeviceGroup();
  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [validationErrors, setValidationErrors] = useState({ name: "" });

  const dragDevice = (e: React.MouseEvent<HTMLElement>) => {
    alert("test");
    e.stopPropagation();
  };

  const handleSubmitGroup = () => {
    if (validateFields()) {
      try {
        setLoading(true);
        const deviceGroup = {
          name: name,
        };

        // TO FIX ERROR CATCHING
        addDeviceGroup(deviceGroup).then((data: any) => {
          setModalOpen(false);
          setLoading(false);
        });
      } catch (error) {
        toast.error(error);
        setLoading(false);
      }
    }
    setName("");
  };

  const handleDeleteGroup = (dataset: any) => {
    // deleteDataset(dataset.id);
  };
  const onClose = () => {
    setModalOpen(false);
  };

  const filterDeviceGroups = (input) => {
    setSearchInput(input);
  };

  useEffect(() => {
    if (!connected) return;
    searchDeviceGroups(searchInput).catch(() => {});
  }, [connected, searchInput]);

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = { name: "" };

    if (validator.isEmpty(name)) {
      newValidationErrors = { ...newValidationErrors, name: "Invalid name" };
      formValidated = false;
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  const groups =
    deviceGroups &&
    deviceGroups.map((group: any, i: any) => (
      <GroupListItem
        title={group.name}
        did={group.id}
        // status={group.status}
        key={i}
      >
        {group.devices.length ? (
          group.devices.map((device: any, y: any) => (
            <DeviceListItem
              device={device}
              groupId={group.id}
              subdevices={device.connectedDevices}
              className={!device.connectedTo && "top-item"}
              key={y}
            />
          ))
        ) : (
          <div className="no-devices">
            <div className="no-devices-icon">
              <DevicesIcon />
            </div>
            <div className="no-devices-text">No devices in this group</div>
          </div>
        )}
      </GroupListItem>
    ));
  return (
    <div className="devices">
      <Header
        title="Devices"
        searchFunction={filterDeviceGroups}
        mainAction={
          <AddButton
            icon={<AddItemIcon />}
            label="New group"
            onClick={() => setModalOpen(true)}
          />
        }
      />

      <div className="devices-content">{groups}</div>
      <Modal
        visible={modalOpen}
        onClose={onClose}
        title="Add new device group"
        onSubmit={handleSubmitGroup}
        submitLoading={loading}
      >
        <Input
          placeholder="Device group name"
          onChange={(e) => setName(e.target.value)}
          className="input-classic"
          status={validationErrors.name && "error"}
          validationMessage={validationErrors.name}
          onPressEnter={handleSubmitGroup}
          value={name}
        />
      </Modal>
    </div>
  );
};

export default Groups;
